import React from "react";
import Facebook from "../img/facebook.svg";
import Twitter from "../img/twitter.svg";
import Logo from "../img/logo-light.png";
import { FacebookShareButton, TwitterShareButton } from "react-share";

const Navbar = ({ url, title }) => {
  return (
    <>
      <div className="navbar d-flex w-100">
        <div className="logo">
          <a href="https://fundacionmohme.org/" target="_blank" rel="noreferrer">
            <img src={Logo} alt="Mohme" />
          </a>
        </div>
        {title && <div>
          <a href="https://fundacionmohme.org/especiales/agua-infraestructura-natural-peru/"><h1 className="text-white">{title}</h1></a>
        </div> }
        <div className="social-media">
          <FacebookShareButton url={url}>
            <img src={Facebook} alt="Facebook" />
          </FacebookShareButton>
          <TwitterShareButton url={url} title ="Historias sobre la seguridad hídrica en el Perú">
            <img src={Twitter} alt="Twitter" />
          </TwitterShareButton>
        </div>
      </div>
    </>
  );
};

export default Navbar;
